var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNdepermisdeconduire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.46094 2.46094H9.84561V3.69172H2.46094V2.46094ZM2.46094 4.9225H9.84561V6.15328H2.46094V4.9225ZM2.46094 7.38406H6.15328V8.61483H2.46094V7.38406ZM2.46094 13.538H4.9225V14.7687H2.46094V13.538Z",
    fill: "#A6ABB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8198 10.6419L13.9737 8.79576C13.8583 8.6804 13.7018 8.61559 13.5386 8.61559C13.3754 8.61559 13.2189 8.6804 13.1035 8.79576L7.38468 14.5146V17.2309H10.101L15.8198 11.5121C15.9352 11.3967 16 11.2402 16 11.077C16 10.9138 15.9352 10.7573 15.8198 10.6419ZM9.59146 16.0001H8.61545V15.0241L11.6924 11.9472L12.6684 12.9232L9.59146 16.0001ZM13.5386 12.053L12.5626 11.077L13.5386 10.101L14.5146 11.077L13.5386 12.053ZM4.92312 17.2309H1.23078C0.904356 17.2309 0.591303 17.1012 0.360487 16.8704C0.129671 16.6396 0 16.3266 0 16.0001V1.23078C0 0.904356 0.129671 0.591303 0.360487 0.360487C0.591303 0.129671 0.904356 0 1.23078 0H11.077C11.4034 0 11.7165 0.129671 11.9473 0.360487C12.1781 0.591303 12.3078 0.904356 12.3078 1.23078V7.38468H11.077V1.23078H1.23078V16.0001H4.92312V17.2309Z",
    fill: "#A6ABB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNdepermisdeconduire);
export default __webpack_public_path__ + "static/media/n de permis de conduire.4a163d2b0f3a61f1e0d75a3a0e81af10.svg";
export { ForwardRef as ReactComponent };